/**
 * Adds decimal separators to a number. E.g. 1000000 -> 1,000,000
 */
export default function formatNumber(number: number): string {
  return number.toLocaleString();
}
